import * as User from './user';

export const { signIn, OAUTH, finishSignIn, register, confirmEmail, forgotPassword, resetPassword, updateCurrentUser } = User;
